import { required, helpers } from "@vuelidate/validators";

import Project from "./project";

export default class Folder {
    constructor() {
        this.id = null;
        this.subDirectory = null;
        this.description = null;
        this.identifier = null;
        this.dtCreate = null;
        this.dtUpdate = null;
        this.project = new Project();
    }

    validations() {
        return {
            subDirectory: {
                required,
                helpers: helpers.regex(/^[a-z-]+$/)
            },
            description: {
                required,
            },
            project: {
                id: {
                    required,
                }
            },
        };
    }
}